<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white"> تقویم کارهای حسابداری و مالی</h3>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">

                                <h5 class="text-accent-light">تقویم کاری</h5>
                                <div class="text-left">
                                    <button class="btn btn-link text-accent-light"
                                        @click="onAddfCalendarClicked()"><i class="fa fa-plus"></i>
                                </button>
                            </div>
                            </div>

                            <div class="col-12 input-group round mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searchingfCalendar()"
                                       placeholder="حداقل 2 کاراکتر از علل باخت را وارد کنید">
                            </div>
                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else>
                                    <div v-if="fCalendars.length===0">
                                        <p class="text-center mt-3">هیچ محدوده زمانی ثبت نشده است. برای ثبت روی دکمه + کلیک
                                            کنید</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                            <tr>

                                                <th>فصل</th>
                                                <th>ماه</th>
                                                <th>آخرین مهلت</th>
                                                <th>شرح کار</th>
                                                <th>جرائم عدم ارائه</th>
                                                <th>جریه عدم پرداخت</th>

                                                <th class="text-center" v-if="role === 'ادمین' || role==='مدیر مالی'"  >عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="item in fCalendars">

                                                <td class="text-nowrap">{{item.season}}</td>
                                                <td class="text-nowrap">{{item.strMoon}}</td>
                                                <td class="text-nowrap">{{showdeadline(item)}}</td>
                                                <td class="text-wrap">{{item.title}}</td>
                                                <td class="text-wrap">{{item.penaltyNotSend}}</td>
                                                <td class="text-wrap">{{item.penaltyNonPayment}}</td>

                                                <td class="text-center text-nowrap" v-if="role === 'ادمین' || role==='مدیر مالی'"  ><i
                                                        class="fa fa-pencil-square-o px-3 clickable "
                                                        style="font-size: larger"
                                                        @click="editfCalendarItem(item)"
                                                        title="ویرایش آیتم"></i>
                                                    | <i class="fa fa-trash-o px-3 clickable"
                                                         style="font-size: larger"
                                                         @click="deletefCalendarItem(item)"
                                                         title="حذف آیتم"></i>

                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal">
                <div class="row p-3">
                    <div class="col-12 text-center">
                        <h1 v-if="fCalendarMode === 'create'">ثبت تقویم کار</h1>
                        <h1 v-else>ویرایش تقویم کار</h1>
                    </div>

                    <div class="col-lg-4 mb-2">
                        <div class="input-group round">

                            <div class="input-group-prepend">
                                <span class="input-group-text">فصل</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused"
                                       @onSearchBlurred="onDropDownBlurred"
                                       ref="evidence"
                                       :data="seasons"
                                       :mode="'create'"
                                       :selected-val="filterSeason"
                                       :header="{multiple: false, label: 'title'}"
                                       aria-placeholder=""
                                       @onChange="onfilterfilterSeasonChange"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-2">
                        <div class="input-group round">

                            <div class="input-group-prepend">
                                <span class="input-group-text">ماه</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused"
                                       @onSearchBlurred="onDropDownBlurred"
                                       ref="evidence"
                                       :data="moons"
                                       :mode="'create'"
                                       :selected-val="filterMoon"
                                       :header="{multiple: false, label: 'title'}"
                                       aria-placeholder=""
                                       @onChange="onfilterfilterMoonChange"></vs-select>
                        </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">روز</span>
                            </div>
                            <input type="number" class="form-control" v-model="fday"
                                   @input="onChangeDay">
                        </div>
                    </div>
                    <div class="col-lg-12 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شرح کار</span>
                            </div>
                            <input class="form-control" v-model="fCalendarModel.title">
                        </div>
                    </div>
                    <div class="col-lg-6 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">جریمه عدم ارسال</span>
                            </div>
                            <input class="form-control" v-model="fCalendarModel.penaltyNotSend">
                        </div>
                    </div>
                    <div class="col-lg-6 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">جریمه عدم پرداخت</span>
                            </div>
                            <input class="form-control" v-model="fCalendarModel.penaltyNonPayment">
                        </div>
                    </div>

                    <div class="col-lg-12 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">سایر توضیحات</span>
                            </div>
                            <input class="form-control" v-model="fCalendarModel.description">
                        </div>
                    </div>

                    <div class="col-lg-6 offset-lg-3 text-center">
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updatefCalendar" v-if="fCalendarMode==='edit'">ویرایش سرفصل
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="createfCalendar" v-else>ثبت سرفصل
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                @click="cancelfCalendar">انصراف
                        </button>
                    </div>
                </div>
            </modal>
            <!--////////////-->

        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Moment from 'moment-jalali';
    import Constants from "../../_framework/Constants";

    export default {
        name: "fCalendar",
        components: {VsSelect, DatePicker},
        data() {
            return {

                isSending: false,
                isLoading: false,

                fCalendars: [{
                    id: 0,
                    day: "",
                    moon: "",
                    season: "",
                    strMoon: "",
                    title: "",
                    penaltyNotSend: "",
                    penaltyNonPayment: "",
                    description:""
                }],

                fCalendarMode: "",
                fCalendarModel: {
                    id: 0,
                    day: "",
                    moon: "",
                    season: "",
                    strMoon: "",
                    title: "",
                    penaltyNotSend: "",
                    penaltyNonPayment: "",
                    description:""
                },
                search: "",

                seasons :[
                    { value : 1 ,title :"بهار"},
                    { value : 2 ,title :"تابستان"},
                    { value : 3 ,title :"پاییز"},
                    { value : 4 ,title :"زمستان"}
                ],
                filterSeason :"",
                moons :[
                    { value : 1 ,title :"فروردین"},
                    { value : 2 ,title :"اردیبهشت"},
                    { value : 3 ,title :"خرداد"},
                    { value : 4 ,title :"تیر"},
                    { value : 5 ,title :"مرداد"},
                    { value : 6 ,title :"شهریور"},
                    { value : 7 ,title :"مهر"},
                    { value : 8 ,title :"آبان"},
                    { value : 9 ,title :"آذر"},
                    { value : 10 ,title :"دی"},
                    { value : 11 ,title :"بهمن"},
                    { value : 12 ,title :"اسفند"},
                ],
                filterMoon :"",
                maxDay :31,
                fday:"",
                role :"",
            }
        },
        mounted() {
            this.getfCalendars();
            this.role = localStorage.getItem('role');
        },
        methods: {

            onfilterfilterSeasonChange(val){
                if (val ) {
                    this.filterSeason = val;
                    this.fCalendarModel.season = this.filterSeason;
                }
            },
            onfilterfilterMoonChange(val){
                if (val ) {
                    this.filterMoon = val;
                    this.fCalendarModel.strMoon = val.title;
                    for(let mon of this.moons) {
                        if(this.filterMoon===mon.title || this.filterMoon.title===mon.title){
                            this.fCalendarModel.moon =mon.value;
                        }
                    }

                    if(parseInt(this.fday)>=31){
                        if(this.fCalendarModel.moon==="NaN" || this.fCalendarModel.moon==="" || parseInt(this.fCalendarModel.moon)<=6){
                            this.fCalendarModel.day=31;
                            this.fday=31;
                        }
                        else if( parseInt(this.fCalendarModel.moon)>=7 && parseInt(this.fCalendarModel.moon)<=11){
                            this.fCalendarModel.day=30;
                            this.fday=30;
                        }
                        if(parseInt(this.fCalendarModel.moon)===12){
                            this.fCalendarModel.day=29;
                            this.fday=29;
                        }
                    }
                    if(this.fCalendarModel.moon<=3){
                        this.filterSeason="بهار";
                        this.fCalendarModel.season ="بهار";
                    }
                    else if(this.fCalendarModel.moon<=6){
                        this.filterSeason="تابستان";
                        this.fCalendarModel.season ="تابستان";
                    }
                    else if(this.fCalendarModel.moon<=9){
                        this.filterSeason="پاییز";
                        this.fCalendarModel.season ="پاییز";
                    }else if(this.fCalendarModel.moon<=12){
                        this.filterSeason="زمستان";
                        this.fCalendarModel.season ="زمستان";
                    }


                }
            },
            onAddfCalendarClicked() {
                this.fCalendarModel = {
                    id:0,
                    day: "",
                    moon: "",
                    season: "",
                    strMoon: "",
                    title: "",
                    penaltyNotSend: "",
                    penaltyNonPayment: "",
                    description:""

                };
                this.fday="";
                this.filterSeason="";
                this.filterMoon="";
                this.fCalendarMode = "create";
                this.$refs.insertModal.showModal();
            },
            getfCalendars() {
                let dateObj = new Date().toJSON();
                let currentDate = this.gregorianToJalali(dateObj, false)
                let moon=parseInt( Moment(currentDate).format('YYYY/MM/DD HH:mm').substr(5,2));
                new BaseService("FinancialCalendar", "/GetFinancialCalendar").getList().then(response => {
                    let count=0;
                    for(let list of response.data){

                        if(parseInt(list.moon)>=moon) {
                            if (count == 0) {
                                this.fCalendars.id = list.id;
                                this.fCalendars.day = list.day;
                                this.fCalendars.moon = list.moon;
                                this.fCalendars.season = list.season;
                                this.fCalendars.strMoon = list.strMoon;
                                this.fCalendars.title = list.title;
                                this.fCalendars.penaltyNotSend = list.penaltyNotSend;
                                this.fCalendars.penaltyNonPayment = list.penaltyNonPayment;
                                this.fCalendars.description = list.description;
                            } else {
                                this.fCalendars.push({
                                    id: list.id,
                                    day: list.day,
                                    moon: list.moon,
                                    season: list.season,
                                    strMoon: list.strMoon,
                                    title: list.title,
                                    penaltyNotSend: list.penaltyNotSend,
                                    penaltyNonPayment: list.penaltyNonPayment,
                                    description: list.description
                                });
                            }
                            count++;
                        }
                    }

                    this.isLoading = true;
                }).catch(error => {
                    console.log(error);
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });

            },
            editfCalendarItem(val) {

                this.fCalendarModel = val;

                this.fday=val.day;
                for(let seas of this.seasons)
                {
                    if(val.season===seas.title)
                    {
                        this.filterSeason=seas.title;

                        break;
                    }
                }
                for(let mon of this.moons)
                {
                    if(val.strMoon===mon.title)
                    {
                        this.filterMoon=mon.title;

                        break;
                    }
                }

                this.fCalendarMode = "edit";
                this.$refs.insertModal.showModal();

            },
            deletefCalendarItem(item) {
                this.isSending=true;
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {
                    new BaseService("FinancialCalendar", "DeleteFinancialCalendar").delete(item.id).then(response => {
                        this.$noty.warning("آیتم با موفقیت حذف شد");
                        this.isLoading = false;
                        this.getfCalendars();
                    }).catch(error => {
                        Utils.handleErrorWithNotification("این آیتم در جای دیگری استفاده شده است، ابتدا موارد وابسته را پاک کنید", this.$noty);
                        this.isLoading = false;
                    })
                }
            },

            updatefCalendar() {
                this.isSending = true;

                if(this.fCalendarModel.season==="")
                {
                    Utils.handleErrorWithNotification("لطفا فصل را انتخاب کنید", this.$noty);
                    this.isLoading = false;
                    return;
                }
                if(this.fCalendarModel.strMoon==="")
                {
                    Utils.handleErrorWithNotification("لطفا ماه را انتخاب کنید", this.$noty);
                    this.isLoading = false;
                    return;
                }
                if(parseInt(this.fCalendarModel.day)===0)
                {
                    Utils.handleErrorWithNotification("لطفا روز را وارد کنید", this.$noty);
                    this.isLoading = false;
                    return;
                }
                if(this.fCalendarModel.title==="")
                {
                    Utils.handleErrorWithNotification("لطفا شرح کار را وارد کنید", this.$noty);
                    this.isLoading = false;
                    return;
                }
                if(this.fCalendarModel.penaltyNotSend==="")
                {
                    Utils.handleErrorWithNotification("لطفا جرائم عدم ارسال را ثبت کنید", this.$noty);
                    this.isLoading = false;
                    return;
                }
                if(this.fCalendarModel.penaltyNonPayment==="")
                {
                    Utils.handleErrorWithNotification("لطفا جرائم عدم پرداخت کنید", this.$noty);
                    this.isLoading = false;
                    return;
                }


                new BaseService("FinancialCalendar", "/UpdateFinancialCalendar").update(this.fCalendarModel).then(response => {
                    this.$noty.success("تقویم کار با موفقیت ویرایش شد");
                    this.isSending = false;
                    this.$refs.insertModal.hideModal();
                    this.isLoading = false;
                    this.getfCalendars();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getfCalendars();
                });


            },
            createfCalendar() {
                this.isSending = true;
                if(this.fCalendarModel.season==="")
                {
                    Utils.handleErrorWithNotification("لطفا فصل را انتخاب کنید", this.$noty);
                    this.isLoading = false;
                    return;
                }
                if(this.fCalendarModel.strMoon==="")
                {
                    Utils.handleErrorWithNotification("لطفا ماه را انتخاب کنید", this.$noty);
                    this.isLoading = false;
                    return;
                }
                if(parseInt(this.fCalendarModel.day)===0)
                {
                    Utils.handleErrorWithNotification("لطفا روز را وارد کنید", this.$noty);
                    this.isLoading = false;
                    return;
                }
                if(this.fCalendarModel.title==="")
                {
                    Utils.handleErrorWithNotification("لطفا شرح کار را وارد کنید", this.$noty);
                    this.isLoading = false;
                    return;
                }
                if(this.fCalendarModel.penaltyNotSend==="")
                {
                    Utils.handleErrorWithNotification("لطفا جرائم عدم ارسال را ثبت کنید", this.$noty);
                    this.isLoading = false;
                    return;
                }
                if(this.fCalendarModel.penaltyNonPayment==="")
                {
                    Utils.handleErrorWithNotification("لطفا جرائم عدم پرداخت کنید", this.$noty);
                    this.isLoading = false;
                    return;
                }
                new BaseService("FinancialCalendar", "/CreateFinancialCalendar").create(this.fCalendarModel).then(response => {
                    this.$noty.success("تقویم کار با موفقیت ثبت شد");
                    this.$refs.insertModal.hideModal();
                    this.isSending = false;

                    this.getfCalendars();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getfCalendars();
                });

            },
            cancelfCalendar() {
                this.$refs.insertModal.hideModal();
                this.getfCalendars();
            },

            searchingfCalendar() {
                if (this.search.length > 2) {
                    this.isLoading = true;
                    new BaseService("FinancialCalendar", `/SearchFinancialCalendar/${this.search}`).getList().then(response => {
                        this.fCalendars = response.data;
                        this.isLoading = false;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                        this.isSending=false;
                    });
                } else {
                    this.getfCalendars();
                }
            },
            showdeadline(val){
              return(val.day+" "+val.strMoon);
            },
            onChangeDay() {

                if (parseInt(this.fday) > 31) {
                    if (this.fCalendarModel.moon === "NaN" || this.fCalendarModel.moon === "" || parseInt(this.fCalendarModel.moon) <= 6) {
                        this.fday = 31;
                    }
                    else if (parseInt(this.fCalendarModel.moon) >= 7 && parseInt(this.fCalendarModel.moon) <= 11) {
                        this.fday = 30;
                    }
                    if (parseInt(this.fCalendarModel.moon) === 12) {
                        this.fday = 29;
                    }
                }
                this.fCalendarModel.day = this.fday;
            },



        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>